// extracted by mini-css-extract-plugin
module.exports = {"container":"SettingsPanel_container__2-aMY"};